import * as Bananas from "bananas-commerce-admin";

import { TableRow } from "@mui/material";

import { DetailedPublicationSchema } from "../../types";
import { formatPublicationRuleName, formatScheduleName } from "../../utils";

export const PublicationRow = ({
  publication,
}: {
  publication: DetailedPublicationSchema;
}) => {
  const { navigate } = Bananas.useRouter();

  const onClick = () => {
    navigate("mediahouse.publications:detail", {
      params: { abbreviation: publication.abbreviation },
    });
  };
  return (
    <TableRow hover sx={{ cursor: "pointer" }} onClick={onClick}>
      <Bananas.TableCell>{publication.name}</Bananas.TableCell>
      <Bananas.TableCell>
        {publication.current_rule != null
          ? formatScheduleName(publication.current_rule)
          : "—"}
      </Bananas.TableCell>
      <Bananas.TableCell>
        {formatPublicationRuleName(publication.current_rule)}
      </Bananas.TableCell>
      <Bananas.TableCell>{publication.nb_confirmed_orders}</Bananas.TableCell>
      <Bananas.TableCell>{publication.nb_orders}</Bananas.TableCell>
    </TableRow>
  );
};
export default PublicationRow;
